module.exports = __webpack_public_path__ + "img/jiax1.1abb633f.png";